module.exports = __webpack_public_path__ + "static/media/How to create and drop stage-wise Templated Invoices.47e70de7.png";